import React from 'react';
import CustomCheckbox from '../CustomCheckbox/CustomCheckbox';
import CustomSelect from '../CustomSelect/CustomSelect';
import './TableRow.css';
import formatPhoneNumber from '../../utils/formatPhoneNumber';
const TableRow = ({
  rowData,
  columns,
  onSelect,
  isSelected,
  handleContextMenu,
  isExpanded,
  onRowClick,
  deleteError,
  showCheckboxes,
}) => {
  return (
    <tr
      onContextMenu={(e) => {
        handleContextMenu(e, rowData);
      }}
      onClick={onRowClick}
      className={`TableRow ${isSelected ? 'selected' : ''} ${
        isExpanded ? 'expanded' : ''
      }`}
    >
      {showCheckboxes && (
        <td className='TableRow__cell'>
          {deleteError && (
            <div className='TableRow__expended-error'>
              {deleteError || null}
            </div>
          )}

          <CustomCheckbox
            onChange={() => onSelect(rowData.id)}
            checked={isSelected}
          />
        </td>
      )}
      {columns.map((column) => {
        let cellValue = rowData[column.key];

        if (column.key === 'is_system') {
          cellValue = rowData[column.key] === 1 ? 'Да' : 'Нет';
        }
        if (column.key === 'phone') {
          cellValue = rowData[column.key]
            ? formatPhoneNumber(rowData[column.key])
            : null;
        }
        if (column.render) {
          return (
            <td key={column.key} className='TableRow__cell'>
              {column.render(rowData)}
            </td>
          );
        }

        if (column.type === 'select') {
          return (
            <td key={column.key} className='TableRow__cell'>
              <CustomSelect
                options={column.options || []}
                placeholder={column.placeholder || 'Выбрать'}
                value={rowData.status}
                onChange={(selected) => {
                  if (column.onChange) {
                    column.onChange(selected, rowData.id);
                  }
                }}
              />
            </td>
          );
        }
        if (column.type === 'status') {
          return (
            <td key={column.key} className='TableRow__cell'>
              {rowData.status !== 'active' ? (
                <div className='TableRow__cell-wrapper-status'>
                  <span
                    className={`TableRow__cell-status ${
                      rowData.status === 'awaiting'
                        ? 'TableRow__cell-status_awaiting'
                        : 'TableRow__cell-status_confirmed'
                    }`}
                  >
                    {' '}
                    {column[rowData.status]}
                  </span>
                  {rowData.status === 'deleted' ? (
                    <button
                      className='TableRow__cell-status-btn'
                      onClick={() => column.buttonInvite.onClick(rowData)}
                    >
                      {column.buttonInvite.title}
                    </button>
                  ) : (
                    <button
                      className='TableRow__cell-status-btn TableRow__cell-status-btn-cancel'
                      onClick={(e) => {
                        e.stopPropagation();
                        column.button.onClick(rowData);
                      }}
                    >
                      {column.button.title}
                    </button>
                  )}
                </div>
              ) : (
                <CustomSelect
                  options={column.options || []}
                  placeholder={column.placeholder || 'Выбрать'}
                  value={rowData.status}
                  onChange={(selected) => {
                    if (column.onChange) {
                      column.onChange(selected, rowData);
                    }
                  }}
                />
              )}
            </td>
          );
        }
        if (column.type === 'statusInvite') {
          return (
            <td key={column.key} className='TableRow__cell'>
              {rowData.status !== 'active' ? (
                <div className='TableRow__cell-wrapper-status'>
                  <span
                    className={`TableRow__cell-status ${
                      rowData.status === 'awaiting'
                        ? 'TableRow__cell-status_awaiting'
                        : 'TableRow__cell-status_confirmed'
                    }`}
                  >
                    {' '}
                    {column[rowData.status]}
                  </span>
                  {rowData.status === 'deleted' ? (
                    <button
                      className='TableRow__cell-status-btn'
                      onClick={() => column.buttonInvite.onClick(rowData)}
                    >
                      {column.buttonInvite.title}
                    </button>
                  ) : (
                    <button
                      className='TableRow__cell-status-btn'
                      onClick={(e) => {
                        column.button.onClick(rowData);
                        e.stopPropagation();
                      }}
                    >
                      {column.button.title}
                    </button>
                  )}
                </div>
              ) : (
                <span>{column[rowData.status]}</span>
              )}
            </td>
          );
        }
        if (column.type === 'anyBtn') {
          return (
            <td key={column.key} className='TableRow__cell '>
              <button
                className='TableRow__cell-status-btn'
                onClick={(e) => {
                  e.stopPropagation();
                  column.button.onClick(rowData);
                }}
              >
                {column.button.title}
              </button>
            </td>
          );
        }
        if (column.type === 'workerBlok') {
          return (
            <td key={column.key} className='TableRow__cell'>
              <div className='TableRow__wrapper-list'>
                <button
                  className='TableRow__cell-status-btn'
                  onClick={(e) => {
                    e.stopPropagation();
                    column.button.onClick(rowData);
                  }}
                >
                  {column.button.title}
                </button>
              </div>
            </td>
          );
        }
        return (
          <td key={column.key} className='TableRow__cell'>
            {cellValue !== undefined && cellValue !== null ? cellValue : ''}
          </td>
        );
      })}
    </tr>
  );
};

export default TableRow;
